import { Doc, DocPath } from "@/components/Doc/Doc";
import { FlashOnChangeTD } from "@/components/FlashOnChange/FlashOnChange";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { Panel } from "@/components/Panel/Panel";
import { totalCapitalInvestedAtom } from "@/financeModels/owasco/companyOwnership";
import { allInvestorTypesAtom } from "@/financeModels/owasco/returnMetrics";
import { monospaceFontFamily } from "@/theme";
import { formatDecimalPercent } from "@/utils/format";
import { formatMoney } from "@/utils/moneyFormating";
import { Table } from "@mantine/core";
import { useAtomValue } from "jotai";

export const CapTableInvestor = () => {
  const total = useAtomValue(totalCapitalInvestedAtom);
  const investorValues = useAtomValue(allInvestorTypesAtom);

  const headers = [
    {
      label: "Investor Type",
      path: "@/docs/pages/model/roi/cap-table-investor-type.mdx" satisfies DocPath,
      props: {},
    },
    {
      label: "Equity Class",
      path: "@/docs/pages/model/roi/cap-table-equity-class.mdx" satisfies DocPath,
      props: {},
    },
    {
      label: "Invested Capital",
      path: "@/docs/pages/model/roi/cap-table-invested-capital.mdx" satisfies DocPath,
      props: {},
    },
    {
      label: "Step-Up Multiple",
      path: "@/docs/pages/model/roi/cap-table-step-up-multiple.mdx" satisfies DocPath,
      props: { ta: "center", w: 90 },
    },
  ] as const;

  return (
    <Panel p={0} w={690}>
      <Table striped withColumnBorders withTableBorder>
        <Table.Thead>
          <Table.Tr>
            {headers.map((col) => (
              <Table.Th key={col.label} {...col.props}>
                <LabelExplainer
                  lh={1.6}
                  label={col.label}
                  explanation={<Doc path={col.path} />}
                />
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ whiteSpace: "nowrap" }}>
          {investorValues
            .filter((row) => row.isVisible)
            .filter((row) => row.id !== "all")
            .map((row) => (
              <Table.Tr key={row.title}>
                <Table.Td>{row.title}</Table.Td>
                <FlashOnChangeTD content={row.equityType?.toString()}>
                  {row.equityType === "common"
                    ? "Common Equity"
                    : "Preferred & Common Equity"}
                </FlashOnChangeTD>

                <FlashOnChangeTD
                  content={row.investedCapital?.toString()}
                  ff={monospaceFontFamily}
                  ta={"right"}
                >
                  {row.investedCapital === null
                    ? ""
                    : formatMoney(Number(row.investedCapital))}
                </FlashOnChangeTD>

                <FlashOnChangeTD
                  content={
                    row.multiplier?.toString() +
                    (row.stepUpElection || "").toString()
                  }
                  ta={"center"}
                >
                  {row.multiplier === null ||
                  !row.stepUpElection ||
                  row.equityType === "common"
                    ? "-"
                    : formatDecimalPercent(
                        Number(row.multiplier) / 100,
                      ).replace("%", "x")}
                </FlashOnChangeTD>
              </Table.Tr>
            ))}
          <Table.Tr bg={"infomatic.0"} fw={"bold"}>
            <Table.Td>Total</Table.Td>
            <Table.Td></Table.Td>
            <Table.Td
              content={total?.toString()}
              ff={monospaceFontFamily}
              ta={"right"}
            >
              {formatMoney(total)}
            </Table.Td>
            <Table.Td></Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Panel>
  );
};
